/**
 * The Tip Arrow's rendered box — a plain module so the web and native
 * `TipArrow` files share it without importing each other (Metro resolves
 * `./TipArrow` to the `.native` file, so a re-export from there is a cycle).
 *
 * MUST match the artwork's viewBox: Radix sizes the svg with these AND adds
 * `height` to the content's side offset to reserve room for the arrow, so a
 * box shorter than the artwork silently clips it (see `TipArrow`).
 */
export const TIP_ARROW_SIZE = { width: 10, height: 7 } as const;

/**
 * Radix offsets the content by `sideOffset + arrowHeight`, so a raw
 * `sideOffset` measures the gap left *below* the arrow rather than the gap to
 * the trigger — a `sideOffset={8}` box ends up 15px away and reads as floating
 * over the neighbouring row. Our `sideOffset` means "gap between trigger and
 * the floating box" (the arrow lives inside it), which is what
 * `absoluteFor` already does on native — so subtract the arrow back out.
 */
export function radixSideOffset(sideOffset: number): number {
  return Math.max(0, sideOffset - TIP_ARROW_SIZE.height);
}
